import { render, staticRenderFns } from "./actAcceptanceModal.vue?vue&type=template&id=24664468&scoped=true&"
import script from "./actAcceptanceModal.vue?vue&type=script&lang=js&"
export * from "./actAcceptanceModal.vue?vue&type=script&lang=js&"
import style0 from "./actAcceptanceModal.vue?vue&type=style&index=0&id=24664468&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24664468",
  null
  
)

export default component.exports